import {
    GameGridSubcategoriesActionsDeviceTypesEnum as ActionsDeviceTypesEnum
} from '../../../shared/src/enums/game-grid-subcategories-actions-device-types.enum';

export const SubcategoriesActionsService = {
    /**
     * Converts configs from {option: bool} to [option] format
     * @param originalConfigs
     * @return Object
     */
    unifyConfigs(originalConfigs) {
        if (originalConfigs === null) {
            return null;
        }

        const unifiedConfigs = JSON.parse(JSON.stringify(originalConfigs));
        const deviceTypes = Object.keys(unifiedConfigs);

        deviceTypes.forEach(deviceType => {
            if (Array.isArray(unifiedConfigs[deviceType])) {
                return;
            }

            unifiedConfigs[deviceType] = Object.keys(unifiedConfigs[deviceType])
                .filter(option => unifiedConfigs[deviceType][option]);
        });

        return unifiedConfigs;
    },

    // Either screenWidth or isMobile should be used.
    getOptionsList({
        configs,
        screenWidth = null,
        isMobile = null,
    }) {
        if (!configs || (screenWidth === null && isMobile === null)) {
            return null;
        }

        const isMobileDevice = (isMobile !== null && isMobile)
            || (screenWidth !== null && screenWidth < 1024);

        const deviceType = isMobileDevice
            ? ActionsDeviceTypesEnum.MOBILE_WEB
            : ActionsDeviceTypesEnum.DESKTOP_WEB;
        const deviceTypes = [
            deviceType,
            ActionsDeviceTypesEnum.ALL,
        ];

        for (const deviceType of deviceTypes) {
            if (configs?.[deviceType]?.length > 0) {
                return configs[deviceType];
            }
        }

        return null;
    },

    checkOptionAvailability({
        optionToCheck,
        optionsList,
    }) {
        if (!optionsList) {
            return false;
        }

        return optionsList?.includes(optionToCheck);
    },

    isAnyOptionAvailable({
        optionsToCheck,
        optionsList,
    }) {
        if (!optionsList) {
            return false;
        }

        return optionsToCheck.some(optionToCheck => this.checkOptionAvailability({
            optionToCheck,
            optionsList,
        }));
    },
};
